class TestDataGenerator {

  generateUserPropertyNames() {

    const propertyNames = ['Category', 'Gender', 'Segment', 'Role', 'Company', 'Signed up', 'Purchased', 'Frequent', 'Infrequent'];

    const propertyNameObjects = [];

    for (let propertyName of propertyNames) {
      propertyNameObjects.push({
        name: propertyName,
        type: 'string'
      });
    }

    return propertyNameObjects;

  }

  doGenerateUserPropertyNameValues(propertyName) {

    const propertyNames = ['Category', 'Gender', 'Segment', 'Role', 'Company', 'Signed up', 'Purchased', 'Frequent', 'Infrequent'];

    const propertyNameObjects = [];

    for (let propertyName of propertyNames) {
      propertyNameObjects.push({
        value: propertyName
      });
    }

    return propertyNameObjects;

  }

  async generateUserPropertyNameValues(propertyName) {

    const self = this;

    return new Promise(function resolver(resolve) {

      setTimeout(function someTimeLater() {

        resolve(self.doGenerateUserPropertyNameValues(propertyName));

      }, 100);

    });

  }

}

export default TestDataGenerator;